import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, branch, renderNothing } from 'recompose';

import { queryGetTicketBonusGQL } from '../graphql/ticketRateNotesApi';
import { getTicketId } from '../selectors';
import TicketBonusPercentageForm from './TicketBonusPercentageForm';
import TickeBonusRateForm from './TicketBonusRateForm';

const propTypes = exact({
  /* eslint-disable react/no-unused-prop-types */
  ticketId: PropTypes.number.isRequired,
  /* eslint-enable react/no-unused-prop-types */

  ticket: PropTypes.object.isRequired,
  userTicketBonusForms: PropTypes.array.isRequired,
});

const TicketBonusForm = (props) => {
  const {
    ticket,
    userTicketBonusForms,
  } = props;

  const {
    bonus_type: bonusType,
    billing_hours: billingHours,
    billing_revenue: billingRevenue,
  } = ticket;

  /* NOTE: Wrapper userTicketBonusForms in members for fieldArray rendering.
  * name of fieldArray name needs to match the name of the array object */
  if (bonusType === 'rate') {
    return (
      <TickeBonusRateForm
        initialValues={{ members: userTicketBonusForms }}
        billingHours={billingHours}
        ticket={ticket}
      />
    );
  }
  return (
    <TicketBonusPercentageForm
      initialValues={{ members: userTicketBonusForms }}
      billingRevenue={billingRevenue}
      ticket={ticket}
    />
  );
};

TicketBonusForm.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    ticketId: getTicketId(state),
  };
};
const mapDispatchToProps = {};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withNoTicketId = branch(
  (props) => { return props.ticketId === null; },
  renderNothing,
);

const enhance = compose(
  withRedux,
  withNoTicketId,
  queryGetTicketBonusGQL,
);

export default enhance(TicketBonusForm);
